import { css } from 'emotion'

const colorChanger = (location, isSelected) => {
  if (!('isNew' in location)) return isSelected ? '#448aff' : '#cde6ff'
  if (location.isNew()) {
    return isSelected ? '#FF0F0F' : '#f8999a'
  }

  if (location.isUpdated()) {
    return isSelected ? '#FF8000' : '#facc99'
  }

  if (location.isActive()) {
    return isSelected ? '#448aff' : '#cde6ff'
  } else {
    return isSelected ? '#999999' : '#cccccc'
  }
}

const colorAndOpacity = (location, isSelected) => {
  const color = colorChanger(location, isSelected)
  const transitionTime = '0.2s'

  return css`
    box-sizing: content-box;
    position: absolute;
    border-radius: 50%;
    border: 8px solid ${color};
    width: 8px;
    height: 8px;
    transition: border ${transitionTime};
    box-shadow: 6px 10px 5px -1px rgba(0, 0, 0, 0.32);

    & ::after {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      bottom: -30px;
      left: -6px;
      border: 10px solid transparent;
      border-top: 17px solid ${color};
      transition: border-top ${transitionTime};
    }
  `
}

export default {
  colorAndOpacity,
}
